import React from 'react';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { User } from 'lucide-react';
import SignatureBlock from './SignatureBlock';

/**
 * Bloc de signature de l'intervenant pour un atelier.
 * Wrapper autour de SignatureBlock qui ajoute la précondition métier :
 * tous les statuts de présence des participants doivent être saisis avant
 * que l'intervenant puisse signer.
 */
const IntervenantSignature = ({
  signature,
  participants,
  onSaveSignature,
  onClearSignature,
}) => {
  const allStatusDefined = participants.length > 0 &&
    participants.every(p => p.statut_presence && p.statut_presence !== 'non_defini');
  const statusDefinedCount = participants.filter(p =>
    p.statut_presence && p.statut_presence !== 'non_defini'
  ).length;

  return (
    <div className={`space-y-3 border rounded-xl p-4 ${allStatusDefined ? 'bg-blue-50 border-blue-200' : 'bg-slate-50 border-slate-200'}`}>
      <div className="flex items-center justify-between">
        <Label className="font-bold text-slate-900 flex items-center gap-2">
          <User className="w-4 h-4" />
          Signature de l'intervenant
        </Label>
        {!signature && !allStatusDefined && (
          <Badge variant="outline" className="text-amber-600 border-amber-300">
            En attente ({statusDefinedCount}/{participants.length} présences saisies)
          </Badge>
        )}
        {!signature && allStatusDefined && (
          <Badge className="bg-blue-100 text-blue-700">
            Prêt à signer
          </Badge>
        )}
      </div>

      <SignatureBlock
        signature={signature}
        onSave={(data) => onSaveSignature && onSaveSignature('intervenant', data)}
        onClear={() => onClearSignature && onClearSignature('intervenant')}
        disabled={!allStatusDefined}
        disabledMessage="Veuillez d'abord saisir le statut de présence de tous les participants avant de signer."
      />
    </div>
  );
};

export default IntervenantSignature;
